export default __webpack_public_path__ + "static/media/icon-circle-security.7a67629e.svg";